/**
 * Role keys stored in DB (do not rename without a migration).
 * Display labels follow MBR-057 / MBR-074.
 */
export const ROLES = {
  BORROWER: 'customer',
  PROSUMER: 'admin',
  EMPLOYEE: 'employee',
  EXECUTIVE_LEADER: 'super_admin',
  FOUNDER: 'founder',
};

export const ROLE_LABELS = {
  customer: 'Borrower',
  admin: 'Prosumer',
  employee: 'Employee',
  super_admin: 'Executive Leader',
  founder: 'Founder',
};

/** Roles that can be assigned in admin UI (Founder is never listed here). */
export const ASSIGNABLE_ROLES = [
  { value: ROLES.BORROWER, label: ROLE_LABELS.customer },
  { value: ROLES.PROSUMER, label: ROLE_LABELS.admin },
  { value: ROLES.EMPLOYEE, label: ROLE_LABELS.employee },
  { value: ROLES.EXECUTIVE_LEADER, label: ROLE_LABELS.super_admin },
];

export function roleLabel(role) {
  if (!role) return '';
  return ROLE_LABELS[role] || String(role).replace(/_/g, ' ');
}

export function isBorrower(role) {
  return role === ROLES.BORROWER;
}

export function isProsumer(role) {
  return role === ROLES.PROSUMER;
}

export function isEmployee(role) {
  return role === ROLES.EMPLOYEE;
}

export function isExecutiveLeader(role) {
  return role === ROLES.EXECUTIVE_LEADER;
}

export function isFounder(role) {
  return role === ROLES.FOUNDER;
}

/** Executive Leader or Founder — full platform admin access */
export function isPlatformAdmin(role) {
  return role === ROLES.EXECUTIVE_LEADER || role === ROLES.FOUNDER;
}

/** Prosumer, Employee, or platform admin — can list/add books */
export function isBookOwner(role) {
  return role === ROLES.PROSUMER || role === ROLES.EMPLOYEE || isPlatformAdmin(role);
}
